var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Invoice Matching Non Trade"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Open"}},[_c('open')],1),_c('vs-tab',{attrs:{"label":"Invalid"}},[_c('div',{staticClass:"tab-text"},[_c('invalid')],1)]),_c('vs-tab',{attrs:{"label":"Valid"}},[_c('div',{staticClass:"tab-text"},[_c('valid')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }